import React from 'react';
import DynamicReportContentAutoSlug from '../../../../components/reports/DynamicReportContentAutoSlug';

// Mapeo de reportIds a slugs fallback (en español)
const getFallbackSlug = (reportId) => {
    const slugMap = {
         
        'rfc8950': 'implementacion-del-rfc8950-para-la-transicion-a-ipv6-only-soporte-de-ipv4aas-en-redes-mikrotik',
        'sobreAtaquesDdosInvestigacion': 'investigacion-sobre-ataques-ddos',
        'antiSpoofing': 'estudio-anti-spoofing-en-la-region',
        'analisisDeFuncionamientoDelTrustAnchorTaDeRpkiV1' : 'analisis-de-funcionamiento-del-trust-anchor-ta-de-rpki'
    };
    return slugMap[reportId] || '';
};

function GenericWordPressReport({ displayMode = 'full', lang = 'es', reportId = 'evolucionGlobalRPKI' }) {
    const fallbackSlug = getFallbackSlug(reportId);
    
    return (
        <DynamicReportContentAutoSlug 
            fallbackSlug={fallbackSlug}
        />
    );
}

export default GenericWordPressReport;
